import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '精选卡片', href: '#cards' },
  { label: 'APP下载', href: '#app' },
  { label: '最新快讯', href: '#updates' },
  { label: '精彩视频', href: '#media' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.3)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-[72px] flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-movie-2-fill text-background-950 text-lg"></i>
          </div>
          <span className="text-xl font-bold text-foreground-50 font-heading">
            蚂蚁影视
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-primary-400 transition-colors duration-200 rounded-lg hover:bg-background-200/50 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer rounded-lg hover:bg-background-200/50 transition-colors"
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-300/30">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-sm font-medium text-foreground-200 hover:text-primary-400 hover:bg-background-200/50 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}